import { Component, OnInit, OnDestroy, Compiler } from '@angular/core';
import { Router , ActivatedRoute} from '@angular/router';
import { SDGComponent, Result, ResultData, QuestionCategoryGroup, QuestionCategoryType, QuestionType } from '../../_models/index';
import { AlertService, SDGComponentService, ResultService } from '../../_services/index';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../environments/environment';
import * as $ from 'jquery';

@Component({
  selector: 'app-gender-data',
  templateUrl: './gender-data.component.html',
  styleUrls: ['./gender-data.component.css']
})

export class GenderDataComponent implements OnInit, OnDestroy {
  sdgcomponent$ : Observable<SDGComponent>;
  results$ : Observable<ResultData[]>;
  subscription1:Subscription;
  subscription2:Subscription;
  qcgroups : Array<QuestionCategoryGroup>=[];
  qctypes : Array<any>=[];
  qtypes : Array<QuestionType>=[];
  qctypes_new : Array<any>=[];
  qtypes_new : Array<any>=[];
  rows: any=[];
  rowsobj: Object;
  qtindexobj: Object;
  qtindexrevarr: Array<Object>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sdgComponentService: SDGComponentService,
    private alertService: AlertService,
    private resultService: ResultService,
    private _compiler: Compiler) { }

  ngOnInit() {
    this._compiler.clearCache();
    $(".header_active").removeClass("header_active")
    $(".gender-click").addClass("header_active")

    this.results$ = this.resultService.getResultData(environment.component.gender);
    this.sdgcomponent$ = this.sdgComponentService.getAll(environment.component.gender);
    this.subscription1 = this.sdgcomponent$.subscribe( data => {
          debugger;
          var qtindex = 0;
          var qtindexobj = {};
          var qtindexrevarr = [];
          var qct : any = data['question_category_type'];
          this.qctypes = Array.apply(null, Array(qct.length)).map(function () {});
          //create an array of question category types using order as array index
          var empty_qct_pos,empty_qct;
          for (var i=0; i < qct.length; i++){
            var span = qct[i].question_type.length;
            if (qct[i].name == "g6"){
              span = 4;
            } else if (qct[i].name == "g7"
                      || qct[i].name == "g9"
                      || qct[i].name == "g10"){
              span = 1;
            }
            else if (qct[i].name=="g3")
              span = 5;
            if(qct[i].average)
              span += 1;
            if(qct[i].positive_response_percent)
              span += 1;

            var min_col_width = 0, qctl=0;
            if(qct[i].display_text){
              qctl = qct[i].display_text.length;
              if(qctl>50)
                min_col_width = qctl*2;
            }

            this.qctypes[qct[i].order-1] = {"name":qct[i].name,"span":span,"question_type":qct[i].question_type,
              "category_group":qct[i].category_group, "order":qct[i].order, "display_text": qct[i].display_text,
              "average": qct[i].average, "positive_response_percent": qct[i].positive_response_percent, "min_col_width": min_col_width }
            if (qct[i].name == "g3"){
              empty_qct_pos = qct[i].order;
              empty_qct = {"name":"","span":3,"question_type":"",
              "category_group":qct[i].category_group, "order":qct[i].order,
              "average": qct[i].average, "positive_response_percent": qct[i].positive_response_percent, "min_col_width": min_col_width }
            }if (qct[i].name == "g11"){
              empty_qct_pos = qct[i].order;
              empty_qct = {"name":" ","span":1,"question_type":"",
              "category_group":qct[i].category_group, "order":qct[i].order,
              "average": qct[i].average, "positive_response_percent": qct[i].positive_response_percent, "min_col_width": min_col_width }
            }
          }
          //Add additional empty question category type
          if (empty_qct_pos && empty_qct){
            this.qctypes.splice(empty_qct_pos,0,empty_qct);
          }
          //slice the last element is for Pool
          this.qctypes.splice(-1,1);

          //create an array of question category type groups
          var qcgroup=this.qctypes[0].category_group;
          var groupspan=0;
          for (var i=0; i < this.qctypes.length; i++){
            if(this.qctypes[i].category_group == qcgroup){
              groupspan += this.qctypes[i].span;
            }
            else{
              this.qcgroups.push({"name":qcgroup,"span":groupspan});
              qcgroup = this.qctypes[i].category_group;
              groupspan = this.qctypes[i].span;
            }
          }
          this.qcgroups.push({"name":qcgroup,"span":groupspan});

          //create an array of question types using order as array index going through all qctypes and all qtypes within each qctype
          for (var i=0; i < this.qctypes.length; i++){

            var qctypeobj = this.qctypes[i];
            var qtarr = this.qctypes[i].question_type;
            //create an array of qtypes in one qctype
            var arr = Array.apply(null, Array(qtarr.length)).map(function () {});
            for (var j=0; j < qtarr.length; j++)
              arr[qtarr[j].order-1] = {id:qtarr[j].id,"name":qtarr[j].name,order:qtarr[j].order, display_text:qtarr[j].display_text};

            //add above qtypes into the lookup table for qtypeid => qtypeindex (column order)
            //and reverse lookup columnorder => qtype
            for (var k=0; k < arr.length; k++){
                this.qtypes.push(arr[k]);
              qtindexobj[arr[k].id] = qtindex;
              qtindexrevarr[qtindex] = arr[k].name;
              qtindex++;
            }

            if (qctypeobj.name == "g6"){
              this.qtypes.push({id:0, "name":"","display_text":"% Junior female paid positions",order:this.qtypes[this.qtypes.length-1].order});
              qtindexrevarr[qtindex] = "% Junior female paid positions";
              qtindex++;
              this.qtypes.push({id:0, "name":"","display_text":"% Senior female paid positions",order:this.qtypes[this.qtypes.length-1].order});
              qtindexrevarr[qtindex] = "% Senior female paid positions";
              qtindex++;
              this.qtypes.push({id:0, "name":"","display_text":"% Dir/Exec female paid positions",order:this.qtypes[this.qtypes.length-1].order});
              qtindexrevarr[qtindex] = "% Dir/Exec female paid positions";
              qtindex++;
              this.qtypes.push({id:0, "name":"","display_text":"Proportion of senior women to all senior staff",order:this.qtypes[this.qtypes.length-1].order});
              qtindexrevarr[qtindex] = "Proportion of senior women to all senior staff";
              qtindex++;
            } else if (qctypeobj.name == "g7"){
              this.qtypes.push({id:0, "name":"","display_text":"7. % female contributions",order:this.qtypes[this.qtypes.length-1].order});
              qtindexrevarr[qtindex] = "% female contributions";
              qtindex++;
            } else if (qctypeobj.name == "g9"){
              this.qtypes.push({id:0, "name":"","display_text":"9. The proportion of staff who are female, who are responsible for gender issues in the lead  water ministry /agency for this indicator",order:this.qtypes[this.qtypes.length-1].order});
              qtindexrevarr[qtindex] = "";
              qtindex++;
            } else if (qctypeobj.name == "g10"){
              this.qtypes.push({id:0, "name":"","display_text":"10. What is the proportion of female representation on all national and international scientific or advisory boards that exist for this indicator?",order:this.qtypes[this.qtypes.length-1].order});
              qtindexrevarr[qtindex] = "";
              qtindex++;
            } /*else if (qctypeobj.name == "g11"){
              this.qtypes.push({id:0, "name":"","display_text":"Staff Balance Average %",order:this.qtypes[this.qtypes.length-1].order});
              qtindexrevarr[qtindex] = "Staff Balance Average %";
              qtindex++;
            }*/
            //move qtindex forward to add columns for proportions if needed
            if(qctypeobj.name == "g3"){
              this.qtypes.push({id:0, "name":"", "display_text":"Proportion of positive responses for 'Gender-specific commitments in National policies'",order:this.qtypes[this.qtypes.length-1].order});
              qtindexrevarr[qtindex] = "Proportion of positive responses for 'Gender-specific commitments in National policies'";
              qtindex++;
              this.qtypes.push({id:0, "name":"","display_text":"Proportion of positive responses for 'Gender policies within lead Ministry/ Insitution(s)'",order:this.qtypes[this.qtypes.length-1].order});
              qtindexrevarr[qtindex] = "Proportion of positive responses for 'Gender policies within lead Ministry/ Insitution(s)'";
              qtindex++;
              this.qtypes.push({id:0, "name":"","display_text":"Proportion of positive responses for 'National policy'",order:this.qtypes[this.qtypes.length-1].order});
              qtindexrevarr[qtindex] = "Proportion of positive responses for 'National policy'";
              qtindex++;
            }
            //move qtindex forward to add columns for avearage and response if needed
            if(qctypeobj.average){
              this.qtypes.push({id:0, "name":"","display_text":"Average",order:this.qtypes[this.qtypes.length-1].order});
              qtindexrevarr[qtindex] = "Average";
              qtindex++;
            }
            if(qctypeobj.positive_response_percent){
              this.qtypes.push({id:0, "name":"","display_text":"+ve Response %",order:this.qtypes[this.qtypes.length-1].order});
              qtindexrevarr[qtindex] = "Response";
              qtindex++;
            }
          }
          for (var l=0; l < this.qtypes.length; l++){
            var qtl=0, min_col_width=0;
            if(this.qtypes[l].display_text){
              qtl = this.qtypes[l].display_text.length;
              if (qtl>10)
                min_col_width = qtl*2;
            }
            this.qtypes[l].min_col_width = min_col_width;
          }
          this.qtindexobj = qtindexobj;
          this.qtindexrevarr = qtindexrevarr;
          var ctar = data['category'];
          console.log('ctar');
          console.log(ctar);
          var rows = {};
          var row = {};
          function label_name(ct){
            return ct.name.replace("Target ","").replace("Indicator ","");
          }
          for (var c = 0; c < ctar.length; c++){
            var ct = ctar[c];
            row["catname"] = label_name(ct);
            row["cat_order"] = ct.order;
            var scl = ct.sub_category.length;
            row["rowspan"] = scl;
            var catrow1 = true;
            for (var sc = 0; sc < scl; sc++){
              var newrow = {catname:row["catname"], cat_order:row["cat_order"], rowspan:row["rowspan"]};
              var sct:any = ct.sub_category[sc];
              newrow["subcatname"] = label_name(sct);
              newrow["subcat_order"] = sct.order;
              newrow["catrow"] = catrow1;
              if(sct.order == 2)
                newrow["rowspan"] = 0;
              catrow1 = false;
              //add one in qtindex i.e (qtindex+1) for adding extra column at the end
              var resultsarr = Array.apply(null, Array(qtindex+1)).map(function () {});
              newrow["resultsarr"] = resultsarr;
              rows[sct.id] = newrow;
            }
          }
          console.log('rows');
          console.log(rows);
          this.rowsobj = rows;
          this.subscription2 = this.results$.subscribe( data => {
                for(var i=0;i<data.length;i++){
                  var res = data[i];
                  var colidx = this.qtindexobj[res.question_type];
                  this.rowsobj[res.sub_category].resultsarr[colidx] = res;
                }
                //go through each row
                var data_valid;
                for(var ri in this.rowsobj){
                  data_valid = true;
                  var rowresults = this.rowsobj[ri].resultsarr;
                  var qcat_count = 0, weight_sum = 0, none_1 = false, count_non_empty = 0, all_3 = true, count_1 = 0;
                  var all_3_gender = true, count_1_gender = 0, count_non_empty_gender = 0,
                      all_3_policy = true, count_1_policy = 0, count_non_empty_policy = 0,
                      all_3_national = true, count_1_national = 0, count_non_empty_national = 0,
                      count_male_junior = 0, count_male_senior = 0, count_male_director = 0,
                      count_female_junior = 0, count_female_senior = 0, count_female_director = 0,
                      male_contrib_junior = 0, male_contrib_senior = 0, male_contrib_director = 0,
                      female_contrib_junior = 0, female_contrib_senior = 0, female_contrib_director = 0,
                      gender_count = 0, contrib_count = 0, male_first_pos = 0, contrib_first_pos = 0,
                      staff_count = 0, staff_male = 0, staff_female = 0, staff_first_pos = 0,
                      rep_count = 0, rep_male = 0, rep_female = 0, rep_first_pos = 0,
                      staff_per = 0, rep_per = 0;
                  var curr_qcat_name = '';

                  //go through each result in the row
                  for(var rri = 0; rri < rowresults.length; rri++){

                    var resobj = rowresults[rri];
                    if(resobj)
                      curr_qcat_name = resobj.question_category_type_name;
                    if (resobj && curr_qcat_name == "g1"){
                      if(resobj.value_weight == 1){
                        count_1_gender++;
                        count_1_national++;
                      }
                      all_3_gender = (resobj.value_weight == 3 && all_3_gender);
                      count_non_empty_gender++;
                      count_non_empty_national++;
                    } else if (resobj && curr_qcat_name == "g2"){
                      if(resobj.value_weight == 1){
                        count_1_national++;
                      }
                      all_3_national = (resobj.value_weight == 3 && all_3_national);
                      count_non_empty_national++;
                    } else if (resobj && curr_qcat_name == "g3"){
                      if(resobj.value_weight == 1){
                        count_1_policy++;
                        count_1_national++;
                      }
                      all_3_policy = (resobj.value_weight == 3 && all_3_policy);
                      count_non_empty_policy++;
                      count_non_empty_national++;
                    }
                    if(curr_qcat_name == "g3"){
                      if(!rowresults[rri]){
                        var gender_value = 0, policy_value = 0, national_value = 0;
                        if(!all_3_gender)
                          gender_value = count_1_gender/count_non_empty_gender;
                        if(!all_3_policy)
                          policy_value = count_1_policy/count_non_empty_policy;
                        if(!all_3_national || !all_3_gender || !all_3_policy)
                          national_value = count_1_national/count_non_empty_national;

                        rowresults[rri] = {value:Math.round((gender_value*100)).toString()+"%"}
                        rowresults[rri+1] = {value:Math.round((policy_value*100)).toString()+"%"}
                        rowresults[rri+2] = {value:Math.round((national_value*100)).toString()+"%"}
                      }
                    }
                    if(curr_qcat_name == "g6"){
                      if (resobj){
                        if (gender_count == 0){
                          count_male_junior = parseInt(resobj.value);
                          male_first_pos = rri;
                        } else if (gender_count == 1){
                          count_male_senior = parseInt(resobj.value);
                        } else if (gender_count == 2){
                          count_male_director = parseInt(resobj.value);
                        } else if (gender_count == 3){
                          count_female_junior = parseInt(resobj.value);
                        } else if (gender_count == 4){
                          count_female_senior = parseInt(resobj.value);
                        } else if (gender_count == 5){
                          count_female_director = parseInt(resobj.value);
                        }
                        gender_count++;
                      } else {
                        var res_val = 0;
                        if (gender_count == 6){
                          res_val = count_female_junior / (count_female_junior + count_male_junior);
                        } else if (gender_count == 7){
                          res_val = count_female_senior / (count_female_senior + count_male_senior);
                        } else if (gender_count == 8){
                          res_val = count_female_director / (count_female_director + count_male_director);
                        } else if (gender_count == 9){
                          res_val = (count_female_senior + count_female_director) / (count_female_senior + count_female_director + count_male_senior + count_male_director);
                        }
                        rowresults[rri] = {value:Math.round((res_val * 100)) + "%"}
                        gender_count++;
                      }
                    }
                    if(curr_qcat_name == "g7"){
                      if (resobj){
                        if (contrib_count == 0){
                          male_contrib_junior = parseInt(resobj.value);
                          contrib_first_pos = rri;
                        } else if (contrib_count == 1){
                          male_contrib_senior = parseInt(resobj.value);
                        } else if (contrib_count == 2){
                          male_contrib_director = parseInt(resobj.value);
                        } else if (contrib_count == 3){
                          female_contrib_junior = parseInt(resobj.value);
                        } else if (contrib_count == 4){
                          female_contrib_senior = parseInt(resobj.value);
                        } else if (contrib_count == 5){
                          female_contrib_director = parseInt(resobj.value);
                        }
                        contrib_count++;
                      } else {
                        var res_val = 0;
                        res_val = (female_contrib_junior + female_contrib_senior + female_contrib_director) / (female_contrib_junior + female_contrib_senior + female_contrib_director + male_contrib_junior + male_contrib_senior + male_contrib_director);
                        rowresults[rri] = {value:Math.round((res_val * 100)) + "%"}
                      }
                    }
                    if(curr_qcat_name == "g9"){
                      if (resobj){
                        if (staff_count == 0){
                          staff_male = parseInt(resobj.value);
                          staff_first_pos = rri;
                        } else if (staff_count == 1){
                          staff_female = parseInt(resobj.value);
                        }
                        staff_count++;
                      } else {
                        var res_val = 0;
                        staff_per = (staff_female) / (staff_female + staff_male);
                        rowresults[rri] = {value:Math.round((staff_per * 100)) + "%"}
                      }
                    }
                    if(curr_qcat_name == "g10"){
                      if (resobj){
                        if (rep_count == 0){
                          rep_male = parseInt(resobj.value);
                          rep_first_pos = rri;
                        } else if (rep_count == 1){
                          rep_female = parseInt(resobj.value);
                        }
                        rep_count++;
                      } else {
                        rep_per = (rep_female) / (rep_female + rep_male);
                        rowresults[rri] = {value:Math.round((rep_per * 100)) + "%"}
                      }
                    }
                    if(curr_qcat_name == "g11"){
                      if (!resobj){
                        var res_val = 0;
                        res_val = (staff_per + rep_per) / 2;
                        rowresults[rri] = {value:Math.round((res_val * 100)) + "%"}
                      }
                    }
                  }
                  // removing extra results
                  rowresults.splice(male_first_pos,6);
                  rowresults.splice(contrib_first_pos-6,6);
                  rowresults.splice(staff_first_pos-6-6,2);
                  rowresults.splice(rep_first_pos-6-6-2,2);
                  //removing question type starting with male or female
                  this.qtypes = this.qtypes.filter(function( obj ) {
                      return !obj.name.toLowerCase().startsWith("g6")
                          && !obj.name.toLowerCase().startsWith("g7")
                          && !obj.name.toLowerCase().startsWith("g9")
                          && !obj.name.toLowerCase().startsWith("g10");
                  });
                  for(var rri = 0; rri < rowresults.length; rri++){
                    if(!rowresults[rri]){
                      rowresults[rri]="not entered";
                        //data_valid = false;
                    }
                  }
                  if(data_valid)
                    this.rows.push(this.rowsobj[ri]);
                }
                // Sorting rows
                this.rows.sort((obj1, obj2) => {
                      if (obj1.cat_order == obj2.cat_order){
                        if (obj1.sub_cat_order > obj2.sub_cat_order) {
                    return 1;
                  }
                  if (obj1.sub_cat_order < obj2.sub_cat_order) {
                      return -1;
                    }
                    return 0;
                      }
                  if (obj1.cat_order > obj2.cat_order) {
                    return 1;
                  }
                  if (obj1.cat_order < obj2.cat_order) {
                    return -1;
                  }
                  return 0;
                });
                console.log('this.rows');
                console.log(this.rows);

this.qctypes_new = [
{
'display_text':'1. Gender-specific objectives and commitments within national policies',
'rspan':1,'cspan':5,
'min_col_width':10
},{
'display_text':'2. Do national level stakeholders (government, donors, civil society, research agencies) regularly incorporate gender considerations in studies, reviews or research commissioned to progress this indicator?',
'rspan':2,'cspan':1,
'min_col_width':10
},{
'display_text':'3. The lead Ministry/ Institution in this question have been identified in the Questionnaire - \'Policy & Institutional Assessment\'',
'rspan':1,'cspan':2,
'min_col_width':10
},{
'display_text':'Proportion of positive responses for \'Gender-specific commitments in National policies\'',
'rspan':2,'cspan':1,
'min_col_width':10
},{
'display_text':'Proportion of positive responses for \'Gender policies within lead Ministry/Insitution(s)\'',
'rspan':2,'cspan':1,
'min_col_width':10
},{
'display_text':'Proportion of positive responses for \'National policy\'',
'rspan':2,'cspan':1,
'min_col_width':10
},{
'display_text':'4. How often are lead gender agencies included in decision making for this target?',
'rspan':2,'cspan':1,
'min_col_width':10
},{
'display_text':'5. Is there documented institutional  commitment to promote equality in representation between women and men in the water agency; equal compensation for equal work, and equal opportunities for training?',
'rspan':2,'cspan':1,
'min_col_width':10
},{
'display_text':'6. What is the number of female and male paid staff in the lead Ministry/Institution for this indicator, disaggregated by job category/level and decision-makinh capacity?',
'rspan':1,'cspan':4,
'min_col_width':10
},{
'display_text':'7. What was the level of male and female participation in at least three national-level meetings of Government and public bodies for this indicator this year?',
'rspan':1,'cspan':1,
'min_col_width':10
},{
'display_text':'8. Are there concrete mechanisms (for example, performance-based contracts) in place to compel staff to pursue gender mainstreaming objectives and incentives to reward them for doing so?',
'rspan':2,'cspan':1,
'min_col_width':10
},{
'display_text':'9. How many staff are responsable for gender issues in the lead Ministry/Institution for this indicator?',
'rspan':2,'cspan':1,
'min_col_width':10
},{
'display_text':'10. What is the proportion of female representation on all national and international scientific or advisory boards that exist for this indicator?',
'rspan':2,'cspan':1,
'min_col_width':10
},{
'display_text':'11. Presence of gender-sensitive training at least once a year within responsible water ministries/lead agencies',
'rspan':2,'cspan':1,
'min_col_width':10
},{
'display_text':'Orgnization mainstreaming (average percentage of staff responsable for gender issues and proportion of female representation on national and international scientifc or advisory boards)',
'rspan':2,'cspan':1,
'min_col_width':10
  }
];

this.qtypes_new = [
{
'display_text':'a',
'min_col_width':10
},{
'display_text':'b',
'min_col_width':10
},{
'display_text':'c',
'min_col_width':10
},{
'display_text':'d',
'min_col_width':10
},{
'display_text':'e',
'min_col_width':10
},{
'display_text':'a',
'min_col_width':10
},{
'display_text':'b',
'min_col_width':10
},{
'display_text':'% Junior female paid positions',
'min_col_width':10
},{
'display_text':'% Senior female paid positions',
'min_col_width':10
},{
'display_text':'% Dir/Exec female paid positions',
'min_col_width':10
},{
'display_text':'Proportion of senior women to all senior staff',
'min_col_width':10
},{
'display_text':'% female contributions',
'min_col_width':10
}];

for(var i=0;i<this.qctypes_new.length;i++)
this.qctypes_new[i].min_col_width = parseInt((this.qctypes_new[i].display_text.length*1.5).toFixed(0));

for(var i=0;i<this.qtypes_new.length;i++)
this.qtypes_new[i].min_col_width = parseInt((this.qtypes_new[i].display_text.length*1.5).toFixed(0));

                this.empty_objects([this.rowsobj, this.qtindexobj]);
                data=null;//results$ : Observable<ResultData[]>;
                this.qtindexrevarr=null;//qtindexrevarr: Array<Object>;
              },
              error => {
                this.alertService.error(error);
              });
          data = null;//sdgcomponent$ : Observable<SDGComponent>;
        },
        error => {
          this.alertService.error(error);
        });
  }

  empty_objects(objects_arrays){
    for (var j=0; j<objects_arrays.length; j++){
      var props = Object.getOwnPropertyNames(objects_arrays[j]);
      for (var i = 0; i < props.length; i++) {
        delete objects_arrays[j][props[i]];
      }
    }
  }

  ngOnDestroy() {
    //  used in template
    this.qcgroups = null;
    this.qctypes = null;
    this.qtypes = null;
    this.rows = null;

    if(this.subscription1)
      this.subscription1.unsubscribe();
    if(this.subscription2)
      this.subscription2.unsubscribe();
  }

  genderBtnClick(){
    this.router.navigateByUrl('/sdg/gender')
  }
  quesBtnClick(){
      this.router.navigateByUrl('/sdg/gender-quest')
  }
  dataBtnClick(){
      this.router.navigateByUrl('/sdg/gender-data')
  }
  reportBtnClick(){
      this.router.navigateByUrl('/sdg/gender-report')
  }
}



// WEBPACK FOOTER //
// ./src/app/sdg/gender-data/gender-data.component.ts